'use strict';
//***********************************************************************************
//***********************************************************************************
//**** cn_svg_tool_space_type  : Manipulation of space type
//***********************************************************************************
//***********************************************************************************

import { cn_space_dummy } from '../model/cn_space_dummy';
import { cn_space_type } from '../model/cn_space_type';
import { cn_wall } from '../model/cn_wall';
import { cn_element } from '../model/cn_element';
import { HELPER } from '../utils/cn_wordings';
import { cn_camera } from './cn_camera';
import { cn_svg_map } from './cn_svg_map';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_box } from '../utils/cn_utilities';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_space_dummy_handler } from './cn_space_dummy_handler';
import { cn_question_input } from './cn_inputs';

export class cn_svg_tool_space_type extends cn_svg_tool_creation {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} svg_map
     */
    constructor(svg_map) {
        super(svg_map);
        this.svg_map = svg_map;
        this._mouseover_space = null;
        this.current_space_type = null;
        this._dummy_mode = false;
        this._mouse = null;

        this.element_filter = function (element) {
            return element.constructor == cn_wall
        };

        this.space_labels = [];
    }

    //***********************************************************************************
    /**
     * Open tool
     */
    open_tool() {
        super.open_tool();
        this.push_instruction();
        this.space_labels = this._storey.get_unique_space_labels();
        this.current_space_label =  this.space_labels.length ? this.space_labels.find(sl => sl.element == null) || this.space_labels[0]:null;
    }

    set_dummy_mode(v) {
        this._dummy_mode = v;
    }

    push_instruction() {
        if (this.current_space_type) {
            this.push_instruction_input(HELPER.space_type.creation)
        } else {
            this.push_instruction_input(HELPER.space_type.empty_state)
        }
    }

    get_space_labels() {
        return this._storey.get_unique_space_labels();
    }

    get_current_space_label() {
        return this.current_space_label;
    }

    set_current_space_label(sl) {
        if (!this.space_labels.includes(sl)) return;
        this.current_space_label = sl;
        this.call("current_space_label_change");
    }

    //***********************************************************************************
    /**
     * SVG rendering
     * @param {cn_camera} camera
     * @returns {string} svg rendered
     */
    draw(camera) {
        var html = '';

        if (this.space_labels.length)
            this._scene.spaces.filter(sp => !!sp.unique_label[this._storey.ID]).forEach(sp => html += camera.draw_styled_polygon(sp.inner_polygon,"fill: rgba(100,255,100,0.2)"));

        if (this._mouseover_space) {
            html += this._mouseover_space.draw(camera, ['mouseover']);
        }
        if (this._dummy_mode && this.current_space_type && this._mouse)
            html += camera.draw_move_arrow(this._mouse);

        //*** We need the labelizer active in dummy mode */
        let labelizer = this._map._space_labelizer;
        if (this._dummy_mode) 
        {
            if (!this._handlers.includes(labelizer))
                this._handlers.push(labelizer);
        }
        else if (this._handlers.includes(labelizer))
            this.remove_handler(labelizer);
        
        html += super.draw(camera);
        return html;
    }

    clear_move() {
        super.clear_move();
        this._mouseover_space = null;
        this._mouse = null;
    }

    _change_space_label() {
        this._building.set_space_unique_label(this._mouseover_space,this._storey,this.current_space_label);
        this.current_space_label =  this.space_labels.length ? this.space_labels.find(sl => sl.element == null) || this.space_labels[0]:null;
        this.call("current_space_label_change");
    }

    //***********************************************************************************
    /**
     * click management
     * @param {object} ev
     * @returns {boolean} true if click was used
     */
    click(ev) {
        if (super.click(ev)) return true;

        if (this.space_labels.length) {
            if (this._mouseover_space && this.current_space_label) {
                if (this._mouseover_space.unique_label[this._storey.ID] && this._mouseover_space.unique_label[this._storey.ID] != this.current_space_label)
                {
                    let input = new cn_question_input("Voulez-vous changer l'étiquette de cet espace ?");
                    input.callback = () => {
                        this._change_space_label();
                    };
                    this.call('question_input', input);
                }
                else 
                    this._change_space_label();
            }
            return true;
        }
        else if (this.current_space_type) {
            if (this._dummy_mode) {
                this.push_transaction(`Création d'une pièce`);
                this.push_item_set(this._scene, 'space_dummies');
                let space = new cn_space_dummy(this._scene);
                space.space_type = this.current_space_type;
                space.label_position = ev.mouse_world;
                [...this._scene.space_dummies, this._scene.spaces].forEach(s => {
                    if (space.index <= s.index) space.index = s.index+1;
                });
                this.push_transaction(`Création d'une nouvelle pièces virtuelle`);
                this.push_item_set(this._scene, 'space_dummies');
                this._scene.space_dummies.push(space);
                this._initiate_edition([space]);
                return true;
            }
            const selected_space = this._find_mouseover_space(ev);
            if (selected_space) {
                this.associate_spaces_to_space_type(selected_space);
            }
        }
        return true;
    }



    //***********************************************************************************
    /**
     * passive move management
     * @param {object} ev
     * @returns {boolean} true if passive move was used
     */
    move(ev) {
        

        if (super.move(ev)) return true;

        if (this.current_space_type || this.space_labels.length) {
            if (this._dummy_mode)
                this._mouse = ev.mouse_world;
            else
                this._mouseover_space = this._find_mouseover_space(ev);
            return true;
        }
        return false;
    }

    _find_mouseover_space(ev) {
        var space = this._scene.find_space(ev.mouse_world);
        if (!space || space.outside) return null;
        return space;
    }


    associate_spaces_to_space_type(space) {
        this.push_transaction(`Affectation d'un type de pièce`);
        this.push_item_set(space, ['space_type','space_type_index']);
        space.space_type = this.current_space_type;
        space.space_type_index = 1 + Math.max(...this._storey.scene.spaces.map(sp => sp.space_type_index));
    }

    /**
     * Create a new space type
     *
     * @param {cn_space_type} space_type
     * @return {cn_space_type}
     */
    add_space_type(space_type) {
        this.push_transaction(`Création d'un nouveau type de pièce`);
        this.push_item_set(this._building, 'element_types');
        this._building.add_element_type(space_type);
        return space_type;
    }

    /**
     * Modify space type
     *
      * @param {cn_space_type} space_type
     */
    modify_space_type(space_type) {
        this.push_transaction(`Modification d'un type de pièce`);
        const space_type_in_building = this._building.get_element_type(space_type.ID);
        this.push_item_set(space_type_in_building, ['space_default_name', 'name', 'space_usage', 'heated', 'color']);
        space_type_in_building.name = space_type.name;
        // @ts-ignore
        space_type_in_building.space_default_name = space_type.space_default_name;
        // @ts-ignore
        space_type_in_building.space_usage = space_type.space_usage;
        // @ts-ignore
        space_type_in_building.heated = space_type.heated;
        // @ts-ignore
        space_type_in_building.color = space_type.color;
    }

    /**
     * Delete space type by id
     *
     * @param {cn_space_type} space_type
     */
    delete_space_type(space_type) {
        this.push_transaction(`Suppression d'un type de pièce`);
        this.push_item_set(this._building, 'element_types');
        const space_type_index = this._building.element_types.findIndex(et => et.ID === space_type.ID);
        this._building.element_types.splice(space_type_index, 1);
    }

    /**
     * Set current space type id
     *
     * @param {cn_space_type} current_space_type
     */
    set_current_space_type(current_space_type) {
        this.current_space_type = current_space_type;
        this.push_instruction();
    }

    /**
     * get bounding box of an array of spaces
     * @param spaces
     * @returns {cn_box}
     */
    get_box(spaces) {
        let box = new cn_box();
        for (const s in spaces) {
            if (spaces[s]) {
                for (var i in spaces[s].contours) {
                    box.enlarge_box(spaces[s].contours[i].get_bounding_box());
                }
            }
        }
        return box;
    }
    
    //***********************************************************************************
    //**** Edition elements
    //***********************************************************************************
    /**
     * TODO : derivate in order to allow edition of other element in the process of creation
     * @param {cn_mouse_event} mouse_event
     * @returns {cn_element}
     */
    _find_other_element(mouse_event) {
        return this._scene.find_space_dummy(mouse_event.mouse_world, mouse_event.camera.snap_world_distance);
    }

    /**
     * TODO : derivate in order to provide an edition handler
     * @param {Array<cn_space_dummy>} elements
     * @returns {cn_edition_handler}
     */
    _build_edition_handler(elements) {
        return new cn_space_dummy_handler(elements, this._map);
    }
    
}

